/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  visible: false,
  spins: [],
  prize: null,
  bet: 0,
};

const reducers = {
  showRoulette: (state, action) => {
    state.visible = true;
    state.spins = action.payload.spins;
    state.prize = action.payload.prize;
    state.bet = action.payload.bet ?? 0;
  },
  hideRoulette: (state) => {
    state.visible = false;
    state.spins = [];
    state.prize = null;
    state.bet = 0;
  },
};

export const roulette = createSlice({
  name: 'roulette',
  initialState,
  reducers,
});
